module.exports = "/Public/build/72c916ce98494e0acd48991392013a3f.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/feature-article-logo-color.svg
// module id = 834
// module chunks = 0